import React, {Suspense, useState, useEffect} from 'react'
import _ from '/home/ps/root'
import vw from '/home/ps/view/view'
import './index.css'
import {connect} from 'react-redux'
const Status = React.lazy(() => import('../../state/view/status'))
// import Status from '../../state/view/status'
import Loading from '../../state/view/loading'
import {cache} from '../../../global'
import {tcp} from '../../../io'
export const ID = 'footer'
var P=false
let lazyLoad = false
const Footer = prop => {
  const {uarr, darr, uid, vid, lang, emptyStore, verb, visit, connected, vendor, u, cookie, master, param, login, cart=''} = prop.master
  const park = { ...prop.park }
  if (vid==_.QID) return null
  if (!(u=='store' || _.Q_.includes(u) || u=='online') || window.opener) return null
  const p = prop.prop(ID)
  const s = prop[ID]
  const show = s.state=='show'
  const username = cookie.username
  const vendorname = vendor.username
  // const shard = uid < 0 ? cookie.p : cookie.home
  const shard = cookie.p
  const display = `${master.go.i} ${master.shop.i}`
  const onClick = e => {
    e.preventDefault()
    e.stopPropagation()
    prop.slide(ID)
    setTimeout(() => prop.slide('l', 'hide'), 1)
    setTimeout(() => prop.slide('t', 'hide'), 1)
  }
  if (show) {
    // lazyLoad = true
    // if (!P && !connected && uid!=vid) {
    if (!P && !connected) {
      P=true
      const buff = {}
      const k = 'offline'
      const cerror = park.error?.[k] || cache(`${lang}error${k}`)
      const csuggest = park.suggest?.[k] || cache(`${lang}suggest${k}`)
      const ccart = park.cart?.[k] || cache(`${lang}cart${k}`)
      const crecommend = park.recommend?.[k] || cache(`${lang}recommend${k}`)
      if (!cerror) buff.error = k
      if (!csuggest) buff.suggest = k
      if (!ccart) buff.cart = k
      if (!crecommend) buff.recommend = k
      // const net = {debug: ID, type: 'p', vendor: Object.values(vendor), lang}
      const net = {type: 'p', vendor: Object.values(vendor), lang}
      // const request = {type: 'p', vendor: Object.values(vendor), lang}
      // const net = {type: 'p', vendor, lang}
      // const net = {type: 'p', vid, lang}
      const cached = Object.keys(buff).length == 0
      if (!cached) net.cache = buff
      // if (!cached) request.cache = buff
      if (!cached || (vid!=uid)) tcp(net)
      // if (!cached || (vid!=uid)) tcp2({request, parking: false})
    }
  } else P=false
  // const style = {
  // }
  return (
    <>
      <div {...p} style={{borderRadius: '7px 7px 0 0'}}>
        <div className='mount icon' onClick={onClick} style={{marginTop: '-24px'}}>
          <span style={{background: vw.THEME, padding: '6px 12px', color: 'white', fontWeight: 'bold', fontSize: '1.2rem', borderRadius: '7px 7px 0 0'}}>
            {connected ? master.exit.i : master.go.i} {master.shop.i} {show ? darr : uarr}
          </span>
        </div>
        {/*lazyLoad && */(u=='store' || _.Q_.includes(u) || u=='online') &&
          <Suspense fallback={<Loading/>}>
          {
            show &&  <Status {...prop}/>
          }
          </Suspense>
        }
      </div>
    </>
  )
}
Footer.ID = ID
export default Footer
